import { useState, useEffect } from 'react';
import { subscribeToActiveBootcamps } from '@/services/bootcamp';
import type { Bootcamp } from '@/types/bootcamp';
import BootcampCard from './BootcampCard';
import styles from '@/pages/main/_index.module.css';

const BootcampCards = () => {
  const [bootcamps, setBootcamps] = useState<Bootcamp[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToActiveBootcamps((data) => {
      setBootcamps(data);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div className={styles.signupGrid}>
        <div className={styles.signupCard}>
          <div className={styles.signupLocation}>Loading bootcamps...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.signupGrid}>
        <div className={styles.signupCard}>
          <div className={styles.signupLocation}>Unable to load bootcamps</div>
        </div>
      </div>
    );
  }

  if (bootcamps.length === 0) {
    return (
      <div className={styles.signupGrid}>
        <div className={styles.signupCard}>
          <div className={styles.signupLocation}>No upcoming bootcamps at this time</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.signupGrid}>
      {bootcamps.map((bootcamp) => (
        <BootcampCard key={bootcamp.id} bootcamp={bootcamp} />
      ))}
    </div>
  );
};

export default BootcampCards;
